angular.module("vgresiduos").controller("OrganizationPermissionGroupEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/perfil-acesso/${$stateParams.id}`);
		};
	}
]);
